module.exports = __webpack_public_path__ + "img/iphone.5b836366.png";